import { create } from 'zustand'

type InitialStateType = {
  name: string
  websiteText: string
  websiteUrl: string
}

const initialState: InitialStateType = {
  name: 'Your venue name',
  websiteText: 'Your website',
  websiteUrl: ''
}

interface TableCardState extends InitialStateType {
  setName: (name: string) => void
  setWebsiteText: (text: string) => void
  setWebsiteUrl: (url: string) => void
  reset: () => void
}

export const useMobileAppDataStore = create<TableCardState>(set => ({
  ...initialState,
  setName: (name: string) => set({ name }),
  setWebsiteText: (websiteText: string) => set({ websiteText }),
  setWebsiteUrl: (websiteUrl: string) => set({ websiteUrl }),
  reset: () => set(initialState)
}))
